import { render } from "./login-modal.vue?vue&type=template&id=66a0e7ff&scoped=true"
import script from "./login-modal.vue?vue&type=script&lang=js"
export * from "./login-modal.vue?vue&type=script&lang=js"

import "./login-modal.vue?vue&type=style&index=0&id=66a0e7ff&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66a0e7ff"

export default script